import React from 'react'

function LazeCuttingErrorHeader() {
    return (
        <thead className='thead-light LazeCuttingErrorHeader'>
            <tr>
                <th className='item'>Item</th>
                <th className='name'>Tên lô</th>
                <th className='create_at'>Ngày tạo</th>
                <th className='type'>Loại sản phẩm</th>
                <th className='userLaze'>Người cắt laze</th>
                <th className='errorInfo'>Lý do cắt lỗi</th>
                <th className='userMark'>Người đánh dấu lỗi</th>
                <th className='partner'>Đối tác in ép</th>
                <th className='sewing_partner'>Đối tác may</th>
                <th className='errorAt'>Ngày đánh dấu lỗi</th>
            </tr>
        </thead>
    )
}

export default LazeCuttingErrorHeader